import {TableCell} from "@mui/material";
import {FC} from "react";
import {styled} from "@mui/system";


const UserCell = styled(TableCell)(() => ({
  fontWeight: 'bold',
}));


type Props = {
  isCurrentUser: boolean,
  value: string
}
export const ResultCellComponent: FC<Props> = ({isCurrentUser, value}) => {

  if (isCurrentUser) {
    return <UserCell>{value}</UserCell>
  } else {
    return <TableCell>{value}</TableCell>
  }
}
